export default {
  "content": "<g clip-path=\"url(#clip0_30_1344)\"><path d=\"M12 0c6.628 0 12 5.373 12 12s-5.372 12-12 12C5.373 24 0 18.627 0 12h2c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2V0z\" fill=\"#7B61FF\"/></g><defs><clipPath id=\"clip0_30_1344\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};